export const ESSENTIALS_TOOLTIP = 'This feature is not included in your subscription plan.';
